@for (link of links$ | async; track link) {
  <a [routerLink]="pageUrl(link)">{{ link.header }}</a>
}
